import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Booking from "../screens/auth/Booking";
import Profile from "../screens/auth/Profile";
import Courses from "../screens/auth/Courses";
import AddCourse from "../components/AdminSideComponents/DashBoardFooter/Course/AddCourse";
import EditCourse from "../components/AdminSideComponents/DashBoardFooter/Course/EditCourse";
import CourseDetails from "../components/AdminSideComponents/DashBoardFooter/Course/CourseDetails";
import CampusGallery from "../screens/auth/CampusGallery";
import Event from "../screens/auth/Event";
import NewsAndBlog from "../screens/auth/NewsAndBlog";
import AllContacts from "../screens/auth/AllContacts";
import BankAccount from "../screens/auth/BankAccount";
import Applications from "../screens/auth/Applications";
import EditApplication from "../components/AdminSideComponents/DashBoardFooter/OnlineApplication/EditApplication";
import ApplicationDetails from "../components/AdminSideComponents/DashBoardFooter/OnlineApplication/ApplicationDetails";
import Blog from "../screens/users/Blog";
import CoursesDetails from "../screens/users/CoursesDetails";
import Gallery from "../screens/users/Gallery";
import Events from "../screens/users/Events";
import ApplyOnline from "../screens/users/ApplyOnline";
import ExploreCourses from "../components/AdminSideComponents/DashBoardFooter/Course/ExploreCourses";
import AdminTestimonials from "../screens/auth/AdminTestimonials";
import AdminPortfolio from "../screens/auth/AdminPortfolio";
import Portfolio from "../screens/users/Portfolio";
import DiplomaCourses from "../components/User/Home/Courses/DiplomaCourses";
import Farm from "../components/User/Home/Courses/Farm";
import BeautyMakeup from "../components/User/Home/Courses/BeautyMakeup";
import DemoBooking from "../screens/auth/DemoBooking";
import PrivacyPolicy from "../components/User/Home/PrivacyPolicy";
import AddUpcomingCourse from "../components/AdminSideComponents/DashBoardFooter/UpcomingCourse/AddUpcomingCourse";
import EditUpcomingCourse from "../components/AdminSideComponents/DashBoardFooter/UpcomingCourse/EditUpcomingCourse";
import ComingSoon from "../components/common/ComingSoon";
import UpcomingCourseList from "../components/AdminSideComponents/DashBoardFooter/UpcomingCourse/UpcomingCourseList";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/bookings",
    component: <Booking />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/courses",
    component: <Courses />,
  },
  {
    path: "/add-course",
    component: <AddCourse />,
  },
  {
    path: "/edit-course/:id",
    component: <EditCourse />,
  },
  {
    path: "/course-details",
    component: <CourseDetails />,
  },
  {
    path: "/upcoming-courses",
    component: <UpcomingCourseList />,
  },
  {
    path: "/upcoming-courses/add",
    component: <AddUpcomingCourse />,
  },
  {
    path: "/upcoming-courses/edit/:id",
    component: <EditUpcomingCourse />,
  },
  {
    path: "/campus-gallery",
    component: <CampusGallery />,
  },
  {
    path: "/event",
    component: <Event />,
  },
  {
    path: "/news-and-blog",
    component: <NewsAndBlog />,
  },
  {
    path: "/inquiries",
    component: <AllContacts />,
  },
  {
    path: "/bank-account",
    component: <BankAccount />,
  },
  {
    path: "/applications",
    component: <Applications />,
  },
  {
    path: "/edit-application/:id",
    component: <EditApplication />,
  },
  {
    path: "/application-details",
    component: <ApplicationDetails />,
  },
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/admin-testimonials",
    component: <AdminTestimonials />,
  },
  {
    path: "/portfolios-of-students",
    component: <AdminPortfolio />,
  },
  {
    path: "/demo-bookings",
    component: <DemoBooking />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/blog",
    component: <Blog />,
  },
  {
    path: "/courses/:slug",
    component: <CoursesDetails />,
  },
  {
    path: "/upcoming-courses/:id",
    component: <ComingSoon />,
  },
  {
    path: "/gallery",
    component: <Gallery />,
  },
  {
    path: "/events",
    component: <Events />,
  },
  {
    path: "/apply-online",
    component: <ApplyOnline />,
  },
  {
    path: "/explore-courses",
    component: <ExploreCourses />,
  },
  {
    path: "/student-portfolio",
    component: <Portfolio />,
  },
  {
    path: "/diploma-course",
    component: <DiplomaCourses />,
  },
  {
    path: "/global-course",
    component: <Farm />,
  },
  {
    path: "/beauty-and-makeup-course",
    component: <BeautyMakeup />,
  },
  {
    path: "/privacy-policy",
    component: <PrivacyPolicy />,
  },
];
